// extracted by mini-css-extract-plugin
export default {"container":"container__YaxNB","label":"label__mp5VF","shareQuestionContainer":"shareQuestionContainer__H8mPG"};